import type {EagColumnState} from '../types/EagColumnState';

/**
 * Returns the deduplicated list of column keys that should be sent to the server
 * for a data query.
 *
 * Visible column keys come from columnStates (hidden !== true).
 * predefinedColumns are always appended regardless of visibility — they carry
 * technical identifiers (e.g. 'warehouseId') required by the API even when the
 * column is not rendered.
 *
 * Pure utility — no React, no store access. Pass store.getState().columnStates
 * at call time to avoid stale-closure bugs.
 */
export const getVisibleColumnKeys = (
  columnStates: EagColumnState[],
  predefinedColumns: readonly string[]
): string[] => {
  const visibleKeys: string[] = [];
  for (const cs of columnStates) {
    if (!cs.hidden) {
      visibleKeys.push(cs.key);
    }
  }
  return [...new Set([...visibleKeys, ...Array.from(predefinedColumns)])];
};
